import React, {useState} from 'react';

interface provider {
    name: string,
    payment_count: number,
    company_logo: string,
    popup_image_link: string
}

interface PartPayProps {
    total: number;
    providers: provider[]
}

const PartPayDiv = (props: PartPayProps) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [providerSelected, setProviderSelected] = useState('');

    const handleClose = () => {
        setModalOpen(!modalOpen)
    }
    const handleOpen = (providerName: string) => {
        setProviderSelected(providerName)
        setModalOpen(!modalOpen)
    }

    return (
        <div className="part-pay-div">
            <div>
                {
                "Or payments from $" + getLowestPaymentAmount(props.providers, props.total)
                }
            </div>
                {
                    props.providers.map(provider => 
                        <div onClick={() => handleOpen(provider.name)}>
                            <img alt='afterpaylogo' height={25} src={provider.company_logo} className="part-pay-div__logo"/>
                        </div>
                    )
                }
                <div className="part-pay-div__popup-bg" style={{display: modalOpen ? 'block': 'none'}}>
                    <div className="part-pay-div__popup-container">
                        <div className="part-pay-div__popup-container__close" onClick={handleClose}>
                            <i className="material-icons">&#xe5cd;</i>
                        </div>
                        {
                            props.providers.map(provider => 
                                <img src={provider.popup_image_link}  alt={'Part Payments - How it works graphic'} style={{display: providerSelected === provider.name ? 'block' : 'none'}}/>
                            )
                        }
                    </div>
                </div>
                
        </div>
    );
}

const getLowestPaymentAmount = (providers: provider[], total: number) =>{
    let maxPayments = 1;
    providers.forEach(provider => provider.payment_count >= maxPayments ? maxPayments = provider.payment_count:maxPayments);
    return (total/maxPayments).toFixed(2);
}

export default PartPayDiv;